import React from 'react';
import { createRoot } from 'react-dom/client';
import { setConfigManager } from 'selfie-verification';
import crypto from 'crypto-js';
import store from './store';
import { vysionInit } from './utils/helpers';
import { AppProvider } from './contexts/AppContext';
import { MixpanelProvider } from './contexts/MixpanelContext';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import { Provider as ReduxProvider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@material-ui/core';
import theme from './theme/material/theme';
import { getSentryConfig } from './common';
import { DRAGYN_BASE_API_URL, SELFIE_FE_BASIC_AUTH, SELFIE_FE_CONFIG_KEY, api } from 'config/Master';

const shaString = crypto.SHA1(SELFIE_FE_BASIC_AUTH).toString();
const selfieBasicAuthToken = btoa(shaString);

if (selfieBasicAuthToken) {
  setConfigManager({
    apiUrl: DRAGYN_BASE_API_URL,
    token: selfieBasicAuthToken,
    clientId: SELFIE_FE_CONFIG_KEY,
    livelinessCallbackUrl: `${api}/liveness/callback`,
  });
}

vysionInit();

if (process.env.REACT_APP_SENTRY_ENABLED === 'true') {
  Sentry.init(getSentryConfig());
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(
  <AppProvider>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <MixpanelProvider>
          <ReduxProvider store={store}>
            <RouterProvider router={router} />
          </ReduxProvider>
        </MixpanelProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </AppProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
